import { render, staticRenderFns } from "./UpdateNotifySchool.vue?vue&type=template&id=0ef970a4&scoped=true"
import script from "./UpdateNotifySchool.vue?vue&type=script&lang=js"
export * from "./UpdateNotifySchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotifySchool.vue?vue&type=style&index=0&id=0ef970a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef970a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef970a4')) {
      api.createRecord('0ef970a4', component.options)
    } else {
      api.reload('0ef970a4', component.options)
    }
    module.hot.accept("./UpdateNotifySchool.vue?vue&type=template&id=0ef970a4&scoped=true", function () {
      api.rerender('0ef970a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifySchool/UpdateNotifySchool.vue"
export default component.exports